// this file is automatically generated by git.version.ts script
/* tslint:disable max-line-length */
export const versions = {date: 1736992947988, version: '1.6.1.22', revision: '9ab1bcc1d061eff5aeb36f8129cbda186d688819', branch: 'release-1.6.1', tag: '1.6.1.49'};
